import api_comm from "./lib";

async function getCardStatements(session_token, params) {
	return api_comm(
		"post",
		"/finances/api/v2/bankcard/local_card_statement",
		params,
		session_token
	);
}

export default getCardStatements;
